import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"settingsPage"},[_c('Title',{attrs:{"title":"Settings"}}),_vm._v(" Design: "),_c('hr'),_c(VSwitch,{attrs:{"hint":"This toggles the global state of the Vuetify theme","inset":"","label":"Use dark theme","persistent-hint":""},model:{value:(_vm.$vuetify.theme.dark),callback:function ($$v) {_vm.$set(_vm.$vuetify.theme, "dark", $$v)},expression:"$vuetify.theme.dark"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }